'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactackleCore = require('reactackle-core');

exports.default = {
  wrapper: {
    marginX: (0, _reactackleCore.bmodule)(1),
    marginY: (0, _reactackleCore.bmodule)(1),
    zIndex: _reactackleCore.zIndexOverlay,
    itemsSpacing: 2
  },

  item: {
    borderRadius: _reactackleCore.radiusDefault,
    minWidth: '20em',
    maxWidth: '35em',
    fontSize: _reactackleCore.fontSizeBody,
    lineHeight: 1.5,
    paddingY: (0, _reactackleCore.bmodule)(2),
    paddingX: (0, _reactackleCore.bmodule)(3),

    actions: {
      paddingY: (0, _reactackleCore.bmodule)(2),
      paddingX: (0, _reactackleCore.bmodule)(3),
      itemSpacingX: 2,
      itemSpacingY: 2
    },

    colorScheme: {
      default: {
        textColor: _reactackleCore.bodyFontColorAlt,
        backgroundColor: 'rgba(0,0,0,0.8)'
      },
      warning: {
        textColor: _reactackleCore.colorWarningForeground,
        backgroundColor: _reactackleCore.colorWarning
      },
      error: {
        textColor: _reactackleCore.colorErrorForeground,
        backgroundColor: _reactackleCore.colorError
      },
      success: {
        textColor: _reactackleCore.colorSuccessForeground,
        backgroundColor: _reactackleCore.colorSuccess
      },
      info: {
        textColor: _reactackleCore.colorInfoForeground,
        backgroundColor: _reactackleCore.colorInfo
      }
    },

    animation: {
      in: {
        name: _reactackleCore.fadeInDown,
        speed: '300ms',
        timingFunction: 'ease-in'
      },

      out: {
        name: _reactackleCore.fadeOutRight,
        speed: '150ms',
        timingFunction: 'ease-in'
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-alert-area/dist/styles/theme.js
// module id = 523
// module chunks = 0